import React from 'react';
import { ChevronLeftIcon } from 'lucide-react';
type PageType = 'home' | 'commercial' | 'services' | 'residential' | 'reservation';
interface CommercialSolutionsProps {
  onNavigate: (page: PageType) => void;
}
const services: {
  label: string;
  page?: PageType;
}[] = [{
  label: 'konferenční technika'
}, {
  label: 'audiovizuální řešení'
}, {
  label: 'digital signage'
}, {
  label: 'řídící systémy'
}, {
  label: 'AV distribuce'
}, {
  label: 'rezervační systém',
  page: 'reservation'
}, {
  label: 'elektro silnoproud'
}, {
  label: 'elektro slaboproud'
}, {
  label: 'průmyslové řízení'
}, {
  label: 'FVE'
}];
export function CommercialSolutions({
  onNavigate
}: CommercialSolutionsProps) {
  return <section id="komercni" className="w-full bg-white py-12" data-id="element-18">
      <div className="max-w-6xl mx-auto px-6" data-id="element-19">
        <div className="grid grid-cols-1 lg:grid-cols-[1fr_1.6fr] gap-16 items-start" data-id="element-20">
          {/* Left Column - Services List */}
          <div className="flex flex-col items-end text-right" data-id="element-21">
            <h2 className="text-2xl font-normal text-[#707070] tracking-wide mb-8" data-id="element-22">
              KOMERČNÍ ŘEŠENÍ
            </h2>
            <ul className="space-y-2" data-id="element-23">
              {services.map(service => <li key={service.label} data-id="element-24">
                  <a href="#" onClick={e => {
                e.preventDefault();
                if (service.page) onNavigate(service.page);
              }} className="flex items-center justify-end gap-3 text-[#707070] hover:text-[#404040] transition-colors group py-1" data-id="element-25">
                    <span className="text-base" data-id="element-26">{service.label}</span>
                    <img src="https://cdn.magicpatterns.com/uploads/ngsUE6r4TLTc8etnh6qeyU/sipka.png" alt="" className="h-[10px] w-auto opacity-60 group-hover:opacity-100 transition-opacity scale-x-[-1]" data-id="element-27" />
                  </a>
                </li>)}
            </ul>
          </div>

          {/* Right Column - Image */}
          <div className="w-full" data-id="element-28">
            <img src="https://images.unsplash.com/photo-1497366216548-37526070297c?w=1200&h=800&fit=crop&auto=format&q=80" alt="Komerční řešení - moderní kancelář s video stěnou" className="w-full h-auto grayscale" data-id="element-29" />
          </div>
        </div>
      </div>
    </section>;
}